import React, {useEffect, useState} from "react";
import {
    Breadcrumb,
    BreadcrumbItem,
    Button, Card,
    CardBody,
    Container,
    FormGroup,
    Label,
} from "reactstrap";
import {
    AvField,
    AvForm,
    AvInput
} from "availity-reactstrap-validation";
import API from "../../utils/API";
import {Link, useHistory} from "react-router-dom";
import {toastr} from "react-redux-toastr";
import PublisherSelectForm from "../../components/formfields/PublisherSelectForm";

const PublisherUserForm = (props) => {
    const [user, setUser] = useState({name:null,email:null,status:null,sendemail:1,publishers:[],mfadisable:null});
    const [error, setError] = useState(null)

    let history = useHistory();

    const handleChange = (e) => {
        setUser({ ...user, [e.target.name]: e.target.value })
        setError(null)
    };

    const handlePublishersSelect = (name,value) => {
        setUser({ ...user, [name]: value })
        setError(null)
    };

    useEffect(() => {
        if (props.match.params.id) {
            API.get('/admin/publisher/user/item/'+props.match.params.id).then((response) => {
                setUser(response.data.data)
            })
        }
    }, [props]);

    const submit = () => {
        if (props.match.params.id) {
            API.put('/admin/publisher/user/item/edit/'+props.match.params.id,user)
                .then((response) => {
                    toastr.success('Success', 'User was successfully saved')
                    history.push("/user/pubusers")
                })
                .catch(error => {
                    setError('User data')
                })
        }else {
            API.post('/admin/publisher/user/item/add',user)
                .then((response) => {
                    toastr.success('Success', 'User was successfully added')
                    history.push("/user/pubusers")
                })
                .catch(error => {
                    setError('User data')
                })

        }
    }

    const handleCheckboxChange = (e) => {
        setUser({...user, [e.target.name]: e.target.checked ? e.target.value : null})
    }

    return (
        <Container fluid className="p-0">
            <Breadcrumb>
                <BreadcrumbItem>
                    <Link to="/user/pubusers">Publisher users</Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>{props.match.params.id?'Edit':'New'} Publisher User</BreadcrumbItem>
            </Breadcrumb>
            <Card>
                <CardBody>
                    {error &&
                        <div className="text-center text-danger">{error}</div>
                    }
                    <AvForm onValidSubmit={submit}>
                        <FormGroup>
                            <Label>Name</Label>
                            <AvInput onChange={handleChange} required type="text" name="name" value={user.name} placeholder="User full name" />
                        </FormGroup>
                        <FormGroup>
                            <Label>Email</Label>
                            <AvInput onChange={handleChange} required type="email" name="email" value={user.email} placeholder="User email" />
                        </FormGroup>
                        <FormGroup>
                            <Label>Assigned Publishers</Label>
                            <PublisherSelectForm value={user.publishers} onChange={handlePublishersSelect} name={'publishers'}/>
                        </FormGroup>
                        {props.match.params.id &&
                            <FormGroup>
                                <Label>Status</Label>
                                <AvField
                                    type="select"
                                    name="status"
                                    value={user.status}
                                    onChange={handleChange}
                                >
                                    <option value={""}>Not-activated</option>
                                    <option value={1}>Active</option>
                                    <option value={2}>Deactivated</option>
                                </AvField>
                            </FormGroup>
                        }
                        {(!props.match.params.id && user.publishers.length > 0) &&
                            <FormGroup>
                                <Label>Send invitation email</Label>
                                <AvField
                                    type="select"
                                    name="sendemail"
                                    value={user.sendemail}
                                    onChange={handleChange}
                                >
                                    <option value={1}>Yes</option>
                                    <option value={0}>No</option>
                                </AvField>
                            </FormGroup>
                        }
                        <FormGroup>
                            <Label>Disable mfa</Label>
                            <input type="checkbox" className="ml-3 mp-1" size={30} name="mfadisable"
                                   onChange={handleCheckboxChange} value="1" checked={user.mfadisable == 1}/>
                        </FormGroup>
                        <div className="text-center">
                            <Button color="primary">Save</Button>
                        </div>
                    </AvForm>
                </CardBody>
            </Card>
        </Container>
    )
};

export default PublisherUserForm;
